export default __webpack_public_path__ + "static/OpenSansRegular-d4dcc0fbdb60ec6a3870efc9f142668d.woff";